<template>
  <div class="datatime">
    <!-- <div
      class="fs-blue"
      @click="showDateTimePicker"
    >
      {{ value || '请选择' }}
    </div> -->
    <div
      class="btn"
      @click="showDateTimePicker"
    >
      <span
        v-if="defaultValue"
        class="name fs-black"
      >{{ defaultValue }}</span>
      <span
        v-else
        class="name"
      >{{ $t('message["855"]') }}</span>
      <i class="iconfont iconicon-test18" />
    </div>
    <cube-validator
      ref="formItem"
      v-model="data.valid"
      :model="data.fieldvalue"
      :data="data"
      :rules="data.rules"
      :messages="data.messages"
      :immediate="false"
    />
  </div>
</template>

<script>
/* const dateSegmentData = [
  {
    is: 'cube-date-picker',
    title: '选择日期',
    min: new Date(),
    max: new Date(2030, 11, 31)
  },
  {
    day: {
      len: 10
    },
    showNow: false,
    is: 'cube-time-picker',
    title: '选择时间',
    min: new Date(),
    max: new Date(2030, 11, 31)
  }
] */

export default {
  name: 'DateTime',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    let { fieldname, fieldvalue } = this.data
    let title = fieldname
    return {
      title,
      defaultValue: fieldvalue || '',
      date: null,
      time: null
    }
  },
  computed: {
    showTime () {
      const { fieldconfig = {} } = this.data || {}
      const { formatdatetime } = fieldconfig
      if (formatdatetime !== 1) { // 年-月-日
        return true
      }
      return false
    },
    dateFormat () {
      if (!this.showTime) {
        return 'YYYY-MM-DD'
      } else {
        return 'YYYY-MM-DD HH:mm'
      }
    },
    timeH () {
      return this.$t('message["1069"]').split('|')
    }
  },

  created () {
    /* if (!this.timePicker) {
      this.timePicker = this.$createDatePicker({
        title: this.title || this.$t('message["1419"]'),
        min: [0, 0, 0],
        max: [23, 59, 59],
        value: new Date(),
        startColumn: 'hour',
        columnOrder: ['hour', 'minute'],
        columnCount: 2,
        format: {
          hour: 'hh' + this.timeH[0], minute: 'mm ' + this.timeH[1]
        },
        cancelTxt: this.$t('message["1000"]'),
        onSelect: (selectedTime, selectedText, formatedTime) => {
          // console.log(selectedTime, selectedText, formatedTime)
          this.time = formatedTime.map(item => item.split(' ')[0]).join(':')
          this.value = this.date + ' ' + this.time
          this.$emit('change', this.value)
        },
        onCancel: () => {
          this.datePicker.show()
        }
      })
    } */

    /* if (!this.dateSegmentPicker) {
      this.dateSegmentPicker = this.$createSegmentPicker({
        data: this.dateSegmentData,
        onSelect: (selectedDates, selectedVals, selectedTexts) => {
          console.log(selectedDates, selectedVals, selectedTexts)
          this.value = selectedTexts[1].replace(/\//g, '-')
          this.$emit('change', this.value)
        },
        onNext: (i, selectedDate, selectedValue, selectedText) => {
          console.log(selectedDate, selectedValue, selectedText)
          this.dateSegmentData[1].min = selectedDate
          if (i === 0) {
            this.dateSegmentPicker.$updateProps({
              // format: 'hh:mm',
              data: this.dateSegmentData
            })
          }
        }
      })
    } */

    this.initDataPicker()
    this.initTimePicker()
    this.setDefault()
  },
  methods: {
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    setDefault () {
      if (this.value) {
        this.defaultValue = this.value
      } else {
        this.defaultValue = this.data.fieldvalue
      }
    },
    showDateTimePicker () {
      if (this.showTime) {
        this.showTimePicker()
      } else {
        this.showDatePicker()
      }
    },
    showDatePicker () {
      this.datePicker.show()
    },
    showTimePicker () {
      this.timePicker.show()
    },
    initDataPicker () {
      let { defaultValue } = this
      if (!this.datePicker) {
        this.datePicker = this.$createDatePicker({
          title: this.$t('message["1418"]'),
          format: {
            year: 'YYYY',
            month: 'MM',
            date: 'DD'
          },
          min: new Date(2010, 11, 31),
          max: new Date(2030, 11, 31),
          value: defaultValue ? new Date(defaultValue) : new Date(),
          confirmTxt: this.showTime ? this.$t('message["1300"]') : this.$t('message["915"]'),
          onSelect: (date, selectedVal, selectedText) => {
          // console.log(date, selectedVal, selectedText)

            this.date = selectedVal.join('-')

            this.defaultValue = this.date
            this.$emit('change', this.defaultValue)
          },
          onCancel: () => {
          }
        })
      }
    },
    initTimePicker () {
      let { defaultValue } = this
      if (!this.timePicker) {
        this.timePicker = this.$createDatePicker({
          title: this.$t('message["1418"]'),
          format: {
            year: 'YYYY ' + this.$t('message["668"]'),
            month: 'MM ' + this.$t('message["1531"]'),
            date: 'DD ' + this.$t('message["941"]'),
            hour: 'hh ' + this.$t('message["1068"]'),
            minute: 'mm ' + this.$t('message["291"]')
          },
          min: new Date(2010, 11, 31),
          max: new Date(2030, 11, 31),
          value: defaultValue ? new Date(defaultValue) : new Date(),
          columnCount: 5,
          onSelect: (date, selectedVal, selectedText) => {
            // console.log(date, selectedVal, selectedText)

            let text = ''
            this.date = selectedText.map((item, i) => {
              if (i < 2) {
                text += item.split(' ')[0] + '-'
              } else if (i === 2) {
                text += item.split(' ')[0] + ' '
              } else if (i < 4) {
                text += item.split(' ')[0] + ':'
              } else if (i === 4) {
                text += item.split(' ')[0]
              }
            })

            this.defaultValue = text
            this.$emit('change', this.defaultValue)
          },
          onCancel: () => {
          }
        })
      }
    }

    /* showDateSegmentPicker () {
      const time = this.value
      let date = time.split(' ')[0]
      this.dateSegmentData[0].selectedIndex = date
      this.dateSegmentData[1].selectedIndex = time

      this.dateSegmentPicker.show()
    } */
  }
}
</script>

<style lang="scss" scoped>
.datatime {
  flex: 1;
  .btn {
    display: flex;
    flex: 1;
    justify-content: space-between;
    color: #d6d6d6;
  }
  .name {
    line-height: 1;
    align-self: center;
  }

  .iconfont {
    color: #d6d6d6;
  }
}
</style>
